<ap-tabset
  [tabsetId]="'s3-folder-manager-tabset'"
  [styleClass]="'gtw-tabset gtw-tabset-efile-review-attachments'"
  [type]="'underline'"
  [responsive]="false"
  [(activeIndex)]="uploadTabIndex">
  <ap-tab [label]="'Attachments List'">
    <div class="d-flex flex-wrap">
      <div class="flex-fill a-modal-mt-50">
        <div class="ap-mb-spacing-6 d-flex">
          <input aria-label="value seven" class="a-text-input ap-mr-spacing-3 w-auto flex-fill" #searchInput
            (input)="searchAttachments(searchInput.value)" placeholder="Search Attachments">
        </div>
        <div class="a-color-dark a-font-12 a-btn-md ap-mt-spacing-7 ap-mb-spacing-3">{{(attachments$ | async)?.length}}
          Attachments</div>
        <ul class="a-list ap-pr-spacing-7">
          @for (file of attachments$ | async; track $index) {
<li class="a-list-item d-flex align-items-center a-border-bt ap-py-spacing-3 justify-content-between"
           >
            <div>
              <div class="a-h6">{{file.FILE_NAME + '.' + file.FILE_TYPE}}</div>
              <div class="a-h6 font-weight-normal text-truncate">Uploaded By: {{file.UPDATED_BY}}</div>
              <div class="a-text-caption a-text-9e9 font-weight-normal">Uploaded on: {{file.UPDATED_ON}}</div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <ap-button [btnType]="'secondary'" class="ap-mr-spacing-3" (onClick)="downloadFileFromS3(file)">
                  @if (file.isDownloading) {
<ap-loading class="a-mr-10" [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
}
                  @if (!file.isDownloading) {
<span class="Appkit4-icon icon-download-light-fill a-btn-icon"
                   ></span>
}Download
                </ap-button>
                @if (s3FolderManagerInput.canDelete) {
<ap-button [btnType]="'secondary'" class="ap-mr-spacing-3"
                  (onClick)="deleteAttachment(file)">
                  @if (file.isDeleting) {
<ap-loading class="a-mr-10" [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
}
                  @if (!file.isDeleting) {
<span class="Appkit4-icon icon-delete-fill a-btn-icon"></span>
}Delete
                </ap-button>
}
              </div>
            </div>

          </li>
}
        </ul>
      </div>
    </div>
  </ap-tab>
  @if (((attachments$ | async)?.length === 0 || s3FolderManagerInput.canUploadMultipleFiles) && (s3FolderManagerInput && !s3FolderManagerInput.isReadOnlyMode)) {
<ap-tab [label]="'Upload'"
   >
    <gtw-s3-file-upload (on-s3-file-upload)="onFileUpload($event)"></gtw-s3-file-upload>
  </ap-tab>
}
</ap-tabset>
